export { default } from './src/event-registration-wizard';